import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isDeleted", "id", "value", "variant", "onChange", "contentType"],
  _excluded2 = ["isDeleted", "isDistributed", "id", "value", "contentType", "variant", "onChange"];
import "core-js/modules/es.function.name.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import FormField, { useFormFieldContext } from 'components/FormField';
import InlineList from 'components/InlineList';
import useUniqueId from 'hooks/useUniqueId';
import { ASSET_WRITE, hasPrivilege, PLAYLIST_WRITE } from 'utils/privileges';
import getFullUserName from 'utils/getFullUserName';
import AddOrEditButton from '../utils/AddOrEditButton';
import OwnerText from './OwnerText';
import OwnerPickerModal, { NO_OWNER_ID } from './OwnerPickerModal';
var OwnerFieldContent = function OwnerFieldContent(_ref) {
  var isDeleted = _ref.isDeleted,
    id = _ref.id,
    value = _ref.value,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'transparent' : _ref$variant,
    onChange = _ref.onChange,
    _ref$contentType = _ref.contentType,
    contentType = _ref$contentType === void 0 ? 'playlist' : _ref$contentType,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var uniqueId = useUniqueId(id);
  var _useFormFieldContext = useFormFieldContext(),
    labelId = _useFormFieldContext.labelId;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showUserSelector = _useState2[0],
    setShowUserSelector = _useState2[1];
  var hasOwner = !!value;
  return /*#__PURE__*/React.createElement(FormField, _extends({
    as: "span",
    label: t('form_owner'),
    labelId: uniqueId
  }, otherProps), /*#__PURE__*/React.createElement(InlineList, {
    spacing: "xxs",
    "aria-labelledby": labelId,
    align: "middle"
  }, /*#__PURE__*/React.createElement(OwnerText, {
    owner: value
  }), /*#__PURE__*/React.createElement(AddOrEditButton, {
    isEditMode: hasOwner,
    addText: t('actions_add_owner'),
    editText: t('actions_edit_owner'),
    variant: variant,
    onClick: function onClick() {
      return setShowUserSelector(true);
    },
    isDisabled: isDeleted
  })), showUserSelector && /*#__PURE__*/React.createElement(OwnerPickerModal, {
    value: value,
    contentType: contentType,
    onClose: function onClose() {
      return setShowUserSelector(false);
    },
    onSubmit: function onSubmit(selection) {
      var newOwner = selection.selectedItems;
      if (!newOwner || Array.isArray(newOwner) || newOwner.id === NO_OWNER_ID) {
        onChange(null);
      } else {
        onChange({
          id: newOwner.id,
          displayName: newOwner.displayName || getFullUserName(newOwner) || newOwner.name,
          isDeleted: newOwner.is_deleted
        });
      }
      setShowUserSelector(false);
    }
  }));
};
function OwnerField(_ref2) {
  var isDeleted = _ref2.isDeleted,
    isDistributed = _ref2.isDistributed,
    id = _ref2.id,
    value = _ref2.value,
    _ref2$contentType = _ref2.contentType,
    contentType = _ref2$contentType === void 0 ? 'playlist' : _ref2$contentType,
    _ref2$variant = _ref2.variant,
    variant = _ref2$variant === void 0 ? 'transparent' : _ref2$variant,
    onChange = _ref2.onChange,
    otherProps = _objectWithoutProperties(_ref2, _excluded2);
  var isPlaylistType = contentType === 'playlist';
  if (isDistributed || !hasPrivilege(isPlaylistType ? PLAYLIST_WRITE : ASSET_WRITE)) {
    return null;
  }
  return /*#__PURE__*/React.createElement(OwnerFieldContent, _extends({
    value: value,
    onChange: onChange,
    isDeleted: isDeleted,
    variant: variant,
    contentType: contentType,
    id: id
  }, otherProps));
}
export default OwnerField;
export { default as OwnerText } from './OwnerText';
export { default as OwnerPickerModal } from './OwnerPickerModal';
export { NO_OWNER_ID } from './OwnerPickerModal';